var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"center-page"}},[_c('div',{staticClass:"bold",attrs:{"id":"number"}},[_vm._v("404")]),_c('div',{staticClass:"bold",attrs:{"id":"not-found"}},[_vm._v(_vm._s(_vm.$t('not_found_page')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }